// UploadStoryFileInput.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Purpose as AssetPurpose } from '../resource/assetConstants.js';
import {
  Entry as UploadJobType,
  PostDraftField,
} from '../resource/uploadConstants.js';

export const UploadStoryFileInput = ({
  uploadJobType,
  setPostDraftData,
  openPostDraft,
}) => {
  return (
    <StyledUploadStoryFileInput
      type="file"
      accept="image/*,video/*"
      aria-hidden
      multiple={false}
      onClick={({ target }) => {
        target.value = '';
        setPostDraftData({
          key: PostDraftField.ENTRY,
          payload: {
            value: UploadJobType.STORY,
          },
        });
      }}
      onChange={({ target }) => {
        const [file] = target.files;
        const isImage = /image\//i.test(file.type);
        const isVideo = /video\//i.test(file.type);
        if (!isImage && !isVideo) {
          return;
        }
        return openPostDraft({
          purpose: AssetPurpose.POST,
          files: [...target.files],
          uploadJobType,
        });
      }}
    />
  );
};

UploadStoryFileInput.propTypes = {
  uploadJobType: PropTypes.string,
  setPostDraftData: PropTypes.func,
  openPostDraft: PropTypes.func,
};

UploadStoryFileInput.defaultProps = {
  uploadJobType: null,
  setPostDraftData: () => null,
  openPostDraft: () => null,
};

const StyledUploadStoryFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

export default UploadStoryFileInput;
